export function initRequestArticle() {
    const requestForm = document.getElementById("request_item_form");
    if(requestForm) {
        requestForm.addEventListener("submit", function (event) {
            if (!requestForm.checkValidity()) {
                event.preventDefault();
            } else {
                const wrapper = this.closest(".requestWrapper");
                if(wrapper) {
                    wrapper.classList.add("requestWrapper--loading");
                }
            }

        });
    }
}